
import { defineComponent, getCurrentInstance, ref, watch } from "vue";
import { AxiosResponse } from "axios";

import apis, { CreateModel } from "@/apis";
import { AlertQueue } from "@/utils/alertQueue";
import { Modal } from "bootstrap";

import UsageInfo from "@/components/UsageInfo.vue";
import CategoryInfo from "@/utils/categoryInfo";

import { PseudoCreateExtension, pseudoQuarantineMap, resetPseudoCreateExtension } from "@/utils/pseudoTypes";

export default defineComponent({
  setup() {
    const vm = getCurrentInstance();
    
    const createModel = ref({
      content: "",
    } as CreateModel);
    const pseudoExtension = ref({
      qt: undefined,
    } as PseudoCreateExtension );

    watch(pseudoExtension.value, e => {
      const schoolExt = JSON.stringify(e);
      createModel.value.school = schoolExt;
    });

    const hb = ref(null as string | null);

    const showModal = () => {
      const el = vm?.refs["modal"] as Element;
      const bsEl = Modal.getOrCreateInstance(el);
      bsEl?.show();
    }

    const submitContent = async (bypassEmpty?: boolean) => {
      if (!bypassEmpty && ( createModel.value.name === undefined
          || createModel.value.mobile === undefined
          || createModel.value.group === undefined
          || createModel.value.school === undefined )) {
        showModal();
        return;
      }

      try {
        if (hb.value === null)
          hb.value = (await apis.apiGetHeartbeat()).data["requestToken"];

        // eslint-disable-next-line
        let d: AxiosResponse<any, any>;

        if (!hb.value) {
          AlertQueue.danger("app configuration failed");
          return;
        }

        d = await apis.apiPostCreate(createModel.value, hb.value);
        if (!d || d.data.status < 200 || d.data.status >= 300) {
          AlertQueue.warn("提交失败, 请重试");
          return;
        }

        AlertQueue.info("提交成功");

        resetPseudoCreateExtension(pseudoExtension.value);
        apis.resetCreateModel(createModel.value);
      } catch (e) {
        AlertQueue.danger(e);
      }
    };

    const categoryInfo = CategoryInfo.info();

    return {
      createModel,
      pseudoExtension,
      categoryInfo,
      pseudoQuarantineMap,
      submitContent,
    };
  },
  components: {
    UsageInfo,
  },
});
